import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';

interface IProps {
  loanSelected: any;
}

export const BoxPortfolio: React.FC<IProps> = ({ loanSelected, }: IProps) => {

  const isPortfolioType = loanSelected?.loanData['What kind of property is it?'] === 'Portfolio' ? true : false;
  
  return (
    <ContentBox
      label={loanSelected?.name}
      content={
        isPortfolioType ? [
        { field: 'Portfolio addresses', value: loanSelected?.salesforceData?.portfolioAddresses ?? '' },
      ] : []}
    />
  );
}